/**
 * The refund split into subtotal and tax, all in minor units (pence) like the total. The subtotal
 * is rounded to a whole penny and the tax is what's left, so the two always add up to the total.
 */
/**
 * HA-849 PR 3 — a refund of lines, as the server prices it: the lines' value plus tax at the order's
 * rate, rounded to the penny (the sale's own formula, OrderMoney). A custom amount is already the
 * gross handed back, so only lines go through this.
 */
export function refundLinesTotal(linesValue: number, taxRatePercent: number) {
	return linesValue + Math.round((linesValue * taxRatePercent) / 100);
}

export function refundSummary(total: number, taxRatePercent: number) {
	const subtotal = Math.round(total / (1 + taxRatePercent / 100));
	return { subtotal, tax: total - subtotal, total };
}
